<!--
 * @LastEditors: chuhongguang
 * @desc: 仓位分布/绩效明细/归因分析，最下方表格
-->
<template>
  <div class="form">
    <el-table
      :data="this.tableItem"
      border
      style="width: 99%;padding: 0 1px;"
      height="430"
      :row-class-name="tableRowClassName"
      @row-click="clickData">
      <template v-for="(x, col) in colData.col_info">
        <el-table-column
          v-if="x.filter_string && x.format !== 'id'"
          :key="col"
          :sortable="x.sortable"
          :sort-method="(a, b, type) => sortMethod(a, b, x, type)"
          :label="x.name"
          :prop="x.name"
          :column-key="x.name"
          :filters="x.filter_string"
          :filter-multiple="false"
          :filter-method="filterHandler">
        </el-table-column>
        <el-table-column
          v-else-if="x.format !== 'id'"
          :key="col"
          :sortable="x.sortable"
          :sort-method="(a, b, type) => sortMethod(a, b, x, type)"
          :label="x.name"
          :prop="x.name">
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>
<script>
export default {
  props: ['tableItem', 'colData'],
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    sortMethod (a, b, col) {
      var flag
      if (col.format === 'percent') {
        if (a[col.name] === '-') {
          flag = 1
          return flag
        } else if (b[col.name] === '-') {
          flag = -1
          return flag
        }
        if (parseFloat(a[col.name]) > parseFloat(b[col.name])) {
          flag = 1
        } else {
          flag = -1
        }
      } else {
        if (a[col.name] > b[col.name]) {
          flag = 1
        } else {
          flag = -1
        }
      }
      return flag
    },
    filterHandler (value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    tableRowClassName ({row, rowIndex}) {
      // 把每一行的索引放进row
      row.index = rowIndex
    },
    clickData (row, event, column) {
      this.$emit('clickedRow', row, this.tableItem)
    }
  },
  watch: {
    tableItem (newVal, oldVal) {
      this.tableItem = newVal
    },
    colData (newVal, oldVal) {
      this.colData = newVal
    }
  }
}
</script>
<style>
  .form .el-table th {
    background-color: #F2F2F2;
  }
  .form .el-table th>.cell {
    color: #001529;
  }
</style>



// WEBPACK FOOTER //
// src/components/dailyBack/formTable.vue